/** The `tags` area: the Tags page. Owned by the stage 2 slot views
 *  (docs/I18N.md §11). */
export const tags = {
  // --- The selected tag's column -----------------------------------------------
  'tags.page.title': 'Tags',
  'tags.page.notATag': 'Not a tag.',
  'tags.page.groups': 'Groups',
  'tags.page.flows': 'Flows',
  'tags.page.subTags': 'Sub-tags',
  'tags.page.items': 'Items',
  'tags.page.noItems': 'No open items carry it.',
  'tags.page.pager': 'Tagged item pages',
  /** The count beside a tag (`countLabel`): items with it live, and dormant. */
  'tags.count.live': '{count} live',
  'tags.count.dormant': '{count} dormant',
  'tags.count.both': '{live} live · {dormant} dormant',

  // --- The rail ----------------------------------------------------------------
  /** `example`: a typed tag, set apart as code. */
  'tags.rail.empty': 'No tags yet. Type {example} into a title to tag an item.',
  'tags.rail.emptyExample': '#word',
  'tags.rail.filter': 'Filter tags',
  'tags.rail.noMatch': 'No tag matches.',
  'tags.rail.live': 'Live tags',
  'tags.rail.dormant': 'Dormant',
  'tags.rail.dormantTree': 'Dormant tags',

  // --- Rename (the retag) ------------------------------------------------------
  'tags.rename.button': 'Rename',
  'tags.retag.title': 'Rename #{tag}',
  'tags.retag.newName': 'New name',
  'tags.retag.counting': 'Counting the items…',
  'tags.retag.reachAll': {
    one: '{count} item will be renamed.',
    other: '{count} items will be renamed.',
  },
  /** `act` of `total` carriers can be edited; `count` cannot. */
  'tags.retag.reachSome': '{act} of {total} items; {count} you cannot edit keep the old tag.',
  'tags.retag.confirm': 'Rename',
  'tags.retag.cancel': 'Cancel',
  'tags.retag.undo': 'Undo',
  'tags.retag.done': 'OK',
} as const;
